__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@dtbr/appshell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@dtbr-generic/components", "2.1.0", () => (Promise.all([__webpack_require__.e(409), __webpack_require__.e(89), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(409))))));
			register("@dtbr-generic/utility", "2.1.0", () => (__webpack_require__.e(131).then(() => (() => (__webpack_require__(131))))));
			register("@sentry/react", "10.47.0", () => (Promise.all([__webpack_require__.e(399), __webpack_require__.e(89)]).then(() => (() => (__webpack_require__(6399))))));
			register("axios", "1.14.0", () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(4447))))));
			register("react-dom", "19.2.4", () => (Promise.all([__webpack_require__.e(89), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "7.14.0", () => (Promise.all([__webpack_require__.e(610), __webpack_require__.e(89), __webpack_require__.e(709)]).then(() => (() => (__webpack_require__(2610))))));
			register("react", "19.2.4", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("recharts", "3.8.1", () => (Promise.all([__webpack_require__.e(358), __webpack_require__.e(89), __webpack_require__.e(709), __webpack_require__.e(363)]).then(() => (() => (__webpack_require__(358))))));
			initExternal(3847);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};